import { NgModule } from '@angular/core';
import { BrowseListService } from './browselists.service';
import { BrowseListConfigService } from './browselists-config.service';
import { NewRolePreconditionService } from './preconditions/new-role-precondition.service';

@NgModule({
  providers: [
    BrowseListService,
    BrowseListConfigService,
    // preconditions
    NewRolePreconditionService
  ]
})
export class BrowselistsModule { }